<div class="MotFilterContainer">
	<div class="MotFilter">
		<button (click)="toggleMot(mot)" *ngFor="let mot of motFilters" class="MotFilter__button" [attr.aria-label]="(mot.ariaLabel | translate)"
		[ngClass]="['mot-icon-' + MOT_TYPE[mot.type].toLowerCase(), mot.active ? '' : 'inactive']" [attr.aria-pressed]="mot.active"></button>
	</div>
</div>
